import { render, staticRenderFns } from "./DealersEdit.vue?vue&type=template&id=3fce7716&"
import script from "./DealersEdit.vue?vue&type=script&lang=js&"
export * from "./DealersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports